var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldKeyboardOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 22.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h10c.41 0 .75.34.75.75s-.34.75-.75.75H7z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 2C3.79 2 2 3.79 2 6v9c0 2.21 1.79 4 4 4h12c2.21 0 4-1.79 4-4V6c0-2.21-1.79-4-4-4H6zm5 6.32c0 .55-.45 1-1 1s-1-.45-1-1 .44-1 .99-1c.56 0 1.01.45 1.01 1zm-3.15 0c0 .55-.45 1-1 1s-1-.45-1-1 .43-1 .99-1 1.01.45 1.01 1zm-1.09 6.54c-.42 0-.76-.34-.76-.75s.33-.75.74-.75h10.53c.41 0 .75.34.75.75s-.34.75-.76.75H6.76zm6.82-5.79c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h3.68a.749.749 0 1 1 0 1.5h-3.68z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldKeyboardOpen);
export default __webpack_public_path__ + "static/media/vuesax-bold-keyboard-open.873949740d71d63d22faa6cb16076acc.svg";
export { ForwardRef as ReactComponent };